import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useTranslation } from "@i18n/hooks";

type Props = {
	fileId: string;
	connectionId: string;
	onClose: () => void;
	onConfirm: () => void;
};

export const OfferFileDeleteDialog = ({ onClose, onConfirm }: Props) => {
	const { t } = useTranslation("common");

	return (
		<Dialog
			header={t("files.deleteConfirm")}
			visible
			position="center"
			dismissableMask
			modal
			onHide={onClose}
			footer={
				<div className="flex justify-content-end">
					<Button
						label={t("actions.cancel")}
						className="mr-2 p-button-secondary"
						onClick={onClose}
					/>
					<Button label={t("actions.delete")} onClick={onConfirm} />
				</div>
			}
		>
			<p>{t("offerFiles.deleteConfirmMessage")}</p>
		</Dialog>
	);
};
